import { render, staticRenderFns } from "./ListRequireStock.vue?vue&type=template&id=148c490e&scoped=true"
import script from "./ListRequireStock.vue?vue&type=script&lang=js"
export * from "./ListRequireStock.vue?vue&type=script&lang=js"
import style0 from "./ListRequireStock.vue?vue&type=style&index=0&id=148c490e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c490e",
  null
  
)

export default component.exports